import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "setting-helper" }
const _hoisted_2 = {
  slot: "header",
  class: "setting-helper__header"
}
const _hoisted_3 = { style: {"margin-right":"10px","color":"red"} }

import { ref } from 'vue';
import { ElMessage } from 'element-plus';

// 地区数据

export default /*@__PURE__*/_defineComponent({
  __name: 'SettingHelper',
  setup(__props, { expose: __expose }) {

const areas = require('@/assets/data/area.json');

// 行业数据
const rawIndustries = require('@/assets/data/tradeOccupations.json');

const tradeOptions = ref(
  Object.entries(rawIndustries.level0).map(([key, value]) => ({
    value: key,
    label: value,
  }))
);

// 表单数据
const form = ref({
  area: [],
  trade: []
});

// 表单校验规则
const rules = ref({
  area: [{ required: true, message: '请选择地区', trigger: 'change' }],
  trade: [{ required: true, message: '请选择行业', trigger: 'change' }]
});

// 级联选择器属性
const cascaderProps = {
  value: 'code',
  label: 'name',
  children: 'children'
};

// 表单引用
const formRef = ref(null);

// 表单提交
const onSubmit = (): Promise<Object> => {
  return new Promise((resolve, reject) => {
    formRef.value.validate((valid: boolean) => {
      if (valid) {
        resolve({ valid, formData: form.value });
      } else {
        reject({ valid, formData: form.value });
      }
    });
  });
};

// 处理提交按钮点击事件
const handleSubmit = async () => {
  try {
    const valid = await onSubmit();
    if (valid) {
      console.log('Form is valid, proceed with submission.');
    }
  } catch (error) {
    console.log('Form validation failed.');
  }
};

// 表单重置
const onReset = () => {
  formRef.value.resetFields();
};

__expose({ onSubmit, onReset, formData: form.value });

return (_ctx: any,_cache: any) => {
  const _component_svgIcon = _resolveComponent("svgIcon")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "box-card" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_svgIcon, { iconClass: 'hotSpotFlame' })
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "热点内容管理", -1))
        ]),
        _createVNode(_component_el_form, {
          model: form.value,
          rules: rules.value,
          ref_key: "formRef",
          ref: formRef,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "地区：",
              prop: "area"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: form.value.area,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.area) = $event)),
                  style: {"width":"100%"},
                  options: _unref(areas),
                  props: cascaderProps,
                  placeholder: "请选择地区"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "所属行业：",
              prop: "trade"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.value.trade,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.trade) = $event)),
                  multiple: "",
                  style: {"width":"100%"},
                  placeholder: "请选择行业"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tradeOptions.value, ({ label, value }) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: value,
                        label: label,
                        value: value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    })
  ]))
}
}

})